import { jsx as e } from "../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { AlertTypeOption as n } from "./types.js";
import { Icon as t } from "../Icon/Icon.js";
const f = ({ className: r, type: i }) => {
  switch (i) {
    case n.WARNING:
      return /* @__PURE__ */ e(t, { name: "warning-filled", className: r });
    case n.CRITICAL:
      return /* @__PURE__ */ e(t, { name: "cross-circle-fill", className: r });
    case n.HIGHLIGHT:
      return /* @__PURE__ */ e(t, { name: "info-filled", className: r });
    case n.SUCCESS:
    default:
      return /* @__PURE__ */ e(t, { name: "checkmark-circle-fill", className: r });
  }
};
export {
  f as AlertIcon
};
